import { StorageManager } from "./StorageManager";
export * from "./type";
var globalManager = null;
export function initStorageManager(writeKey) {
    if (!globalManager) {
        globalManager = new StorageManager(writeKey);
    }
}
function getStorageInstance(type) {
    if (!globalManager) {
        throw new Error("StorageManager not initialized. Call initStorageManager(writeKey) first.");
    }
    return globalManager.getStorage(type);
}
export var cookie = function () { return getStorageInstance("cookieStorage"); };
export var local = function () { return getStorageInstance("localStorage"); };
export var session = function () { return getStorageInstance("sessionStorage"); };
export var memory = function () { return getStorageInstance("memoryStorage"); };
//# sourceMappingURL=index.js.map